import { useEffect } from "react";
import { Loader } from "components/loader/Loader";
import Modal from "components/modal/Modal";
import LoginForm from "./LoginForm";
import SysMessage from "./SysMessage";
import { useRootStore } from "store";

import "./Login.scss";

export default function Login() {
  const { user } = useRootStore((state) => state);
  const { fetchSysMessage, isNewPass } = useRootStore(
    (state) => state.notifications
  );
  const { isNewPass: userNewPass, sysMessage } = useRootStore(
    (state) => state.user
  );
  const { isAuthenticating } = user;

  useEffect(() => {
    fetchSysMessage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isAuthenticating ? (
        <div
          style={{
            minHeight: "50vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <Loader className="mr-3" /> <p>Loggar in...</p>
        </div>
      ) : (
          <div className="box">
            <SysMessage messageInfo={sysMessage} />
            {userNewPass && (
              <Modal
                onDismiss={() => {
                  isNewPass(false);
                }}
                modalTitle="update password"
              >
                <div>
                  Nu är ditt lösenord uppdaterat. Vänligen logga in igen.{" "}
                </div>
              </Modal>
            )}

            <LoginForm />
          </div>
      )}
    </>
  );
}
